<template>
  <div class="home">
    <Navbar :is-active="6"></Navbar>
    <div class="body">
      <MesasSidebar active="mesas" />
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Mesas</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Nombre de mesa" v-model="table_name" @keyup="search" />
          <input type="text" placeholder="Número" v-model="table_number" @keyup="search" @keypress="onlynumber" />
          <select v-model="table_status" @change="search">
            <option selected="selected" value="">Estado</option>
            <option value="1">Activa</option>
            <option value="0">Inactiva</option>
          </select>
          <p @click="clean_filter()" class="clean_filter">Limpiar Filtros</p>
        </div>
        <div class="page__buttons">
          <button @click="createMesa()" class="button">
            Nueva Mesa <i class="fas fa-plus"></i>
          </button>
          <ButtonExport
            :data="tables_export"
            :columns="columns"
            :sheet-name="'Datos Mesas'"
            :file-name="'Reporte Mesas'"
          />
        </div>
        <div class="page__table">
          <div class="table-headers">
            <p v-for="({ label }, index) of columns" :key="index">
              {{ label }}
            </p>
            <p>Acción</p>
          </div>
          <div class="table-body">
            <div class="data" v-for="table of tables" :key="table.id">
              <p>{{ table.table_number }}</p>
              <p>{{ table.table_name }}</p>
              <p class="cell-uuid" :title="table.table_uuid">{{ table.table_uuid }}</p>
              <p>{{ table.table_status === 1 ? 'Activa' : 'Inactiva' }}</p>
              <p>{{ dateFormat(table.created_at) }}</p>
              <div class="dropdown">
                <button class="button" @click="show('id-dropdown-content'+table.id)">
                  <i class="fa fa-ellipsis" style="color: red"></i>
                </button>
                <div
                  @mouseleave="show('id-dropdown-content'+table.id)"
                  class="dropdown-content"
                  :id="'id-dropdown-content'+table.id"
                >
                  <router-link :to="{ path: '/Client/showmesa', query: { id: table.id }}" class="dropdown-item">
                    <i class="far fa-eye"></i> Ver Detalle
                  </router-link>
                  <button class="dropdown-item" @click="viewQr(table)">
                    <i class="fas fa-qrcode"></i> Visualizar QR
                  </button>
                  <button class="dropdown-item" @click="downloadQr(table)">
                    <i class="fas fa-download"></i> Descargar QR
                  </button>
                  <button class="dropdown-item" @click="deleteMesa(table.id)">
                    <i class="fas fa-trash"></i> Eliminar
                  </button>
                  <div class="dropdown-item-special">
                    Activado
                    <input
                      :id="'check_'+table.id"
                      type="checkbox"
                      :checked="(table.table_status === 1)"
                      class="dropdown-checkbox"
                      @change="activateMesa($event, table.id)"
                    />
                    <label class="wrapper" :for="'check_'+table.id">
                      <span class="circle"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
            :data="pagination"
            v-on:changePage="handleClickInParent"
          />
        </div>
        <vue-final-modal v-model="showQrModal" classes="modal-container" content-class="modal-content">
          <h2 style="text-align: center; margin-bottom: 1rem;">Código QR — {{ qrTitle }}</h2>
          <div style="text-align: center;">
            <img v-if="qrImageUrl" :src="qrImageUrl" alt="QR Mesa" style="max-width: 320px; width: 100%;" />
            <p style="margin-top: 1rem; word-break: break-all; color: #555;">{{ qrUuid }}</p>
          </div>
          <div class="page__buttons" style="padding-top: 2%; justify-content: center;">
            <button
              style="background: #32ba7c; width: 220px; padding: 15px 20px; border-radius: 15px; font-size: 17px; color: #fff; border: none; display: flex; align-items: center; justify-content: space-between; margin-right: 10px;"
              @click="downloadQr(currentQrTable)"
            >
              <span>Descargar QR</span>
              <i class="fas fa-download"></i>
            </button>
            <button
              style="background: #ff3128; width: 180px; padding: 15px 20px; border-radius: 15px; font-size: 17px; color: #fff; border: none; display: flex; align-items: center; justify-content: space-between;"
              @click="closeQrModal"
            >
              <span>Cerrar</span>
              <i class="fa fa-times-circle"></i>
            </button>
          </div>
        </vue-final-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar.vue'
import MesasSidebar from '@/components/MesasSidebar.vue'
import { dateFormat } from '@/utils/formats'
import ButtonExport from '@/components/ButtonExport.vue'
import Pagination from '@/components/Pagination.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import { VueFinalModal } from 'vue-final-modal'
import $ from 'jquery'

export default {
  name: 'Mesas',
  components: {
    Navbar,
    MesasSidebar,
    ButtonExport,
    Pagination,
    OpenArrow,
    VueFinalModal
  },
  data() {
    return {
      tables: [],
      tables_export: [],
      pagination: [],
      empty: false,
      timeout: null,
      table_name: '',
      table_number: '',
      table_status: '',
      showQrModal: false,
      qrImageUrl: '',
      qrUuid: '',
      qrTitle: '',
      currentQrTable: null,
      columns: [
        { label: 'Número', field: 'table_number' },
        { label: 'Nombre', field: 'table_name' },
        { label: 'UUID', field: 'table_uuid' },
        { label: 'Estado', field: 'table_status' },
        {
          label: 'Fecha Registro',
          field: 'created_at',
          dataFormat: this.dateFormat
        }
      ]
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login')
      return
    }
    this.getall()
  },
  beforeUnmount() {
    this.revokeQrUrl()
  },
  methods: {
    dateFormat,
    onlynumber(evt) {
      evt = evt || window.event
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },
    show(divID) {
      if (!$('body').hasClass('cerrarModal')) {
        $('#' + divID).fadeIn()
        setTimeout(function () {
          $('body').addClass('cerrarModal')
        }, 10)
      }
    },
    handleClickInParent(page) {
      this.getall(page)
    },
    clean_filter() {
      this.table_name = ''
      this.table_number = ''
      this.table_status = ''
      this.getall()
    },
    search() {
      clearTimeout(this.timeout)
      const self = this
      this.timeout = setTimeout(function () {
        self.getall(1, {
          table_name: self.table_name,
          table_number: self.table_number,
          table_status: self.table_status
        })
      }, 500)
    },
    async getall(page = 1, paramSearch = {}) {
      try {
        const res = await axios.get('general/table', {
          params: {
            page: page,
            table_company_id: localStorage.getItem('company_id'),
            table_name: paramSearch.table_name || this.table_name || null,
            table_number: paramSearch.table_number || this.table_number || null,
            table_status: paramSearch.table_status || this.table_status || null
          }
        })
        if (res.data.data && res.data.data.total > 0) {
          this.tables = res.data.data.data
          this.pagination = res.data.data
          this.tables_export = res.data.export
          this.empty = false
        } else {
          this.tables = []
          this.pagination = {}
          this.tables_export = []
          this.empty = true
        }
      } catch (e) {
        this.tables = []
        this.pagination = {}
        this.tables_export = []
        this.empty = true
      }
    },
    createMesa() {
      this.$router.push('/Client/addmesa')
    },
    activateMesa(e, id) {
      const data = {
        table_status: e.target.checked ? 1 : 0
      }
      axios.put('general/table/' + id, data).then(() => {
        this.search()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: e.target.checked ? 'Activado correctamente' : 'Desactivado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      })
    },
    async deleteMesa(id) {
      const result = await this.$swal({
        title: '¿Deseas eliminar la mesa?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#ff3128',
        confirmButtonColor: '#32ba7c'
      })

      if (result.isConfirmed) {
        await axios.delete('general/table/' + id)
        this.getall()
        this.$swal({
          position: 'center',
          icon: 'success',
          title: 'Eliminado correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    revokeQrUrl() {
      if (this.qrImageUrl) {
        URL.revokeObjectURL(this.qrImageUrl)
        this.qrImageUrl = ''
      }
    },
    async fetchQrBlob(table, view = false) {
      const response = await axios.get('general/table/' + table.id + '/qr', {
        params: view ? { view: 1 } : {},
        responseType: 'blob'
      })
      return response.data
    },
    async viewQr(table) {
      try {
        this.revokeQrUrl()
        const blob = await this.fetchQrBlob(table, true)
        this.qrImageUrl = URL.createObjectURL(blob)
        this.qrUuid = table.table_uuid
        this.qrTitle = table.table_name + ' (#' + table.table_number + ')'
        this.currentQrTable = table
        this.showQrModal = true
      } catch (e) {
        this.$swal({
          icon: 'error',
          title: 'No se pudo visualizar el QR',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },
    closeQrModal() {
      this.showQrModal = false
      this.revokeQrUrl()
      this.currentQrTable = null
    },
    async downloadQr(table) {
      if (!table) return
      try {
        const blob = await this.fetchQrBlob(table, false)
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'mesa-' + table.table_number + '-' + table.table_uuid + '.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
      } catch (e) {
        this.$swal({
          icon: 'error',
          title: 'No se pudo descargar el QR',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}
</script>

<style scoped>
  .body {
    width: 100%;
    display: flex;
  }

  .body__sidebar {
    width: var(--sidebar-width, 280px);
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .body__containt {
    min-height: 87vh;
    height: fit-content;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
    box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
  }

  .body__containt .page__title {
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .body__containt .page__title h2 {
    font-weight: 600;
    color: #ff3128;
    font-size: 25px;
    margin: 0;
  }

  .body__containt .page__filters {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 40px;
  }

  .body__containt .page__filters input,
  .body__containt .page__filters select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 10px 16px;
    height: 2.75rem;
  }

  .body__containt .page__buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  .body__containt .page__buttons .button {
    width: 250px;
    padding: 15px 20px;
    border-radius: 15px;
    font-size: 17px;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .body__containt .page__buttons .button:nth-child(1) {
    background: #32ba7c;
  }

  .body__containt .page__table {
    width: 100%;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    overflow: visible;
    padding-bottom: 220px;
  }

  .body__containt .page__table .table-headers {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #b6b6b6;
  }

  .body__containt .page__table .table-headers p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    margin: 0;
  }

  .body__containt .page__table .table-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #b6b6b6;
    overflow: visible;
  }

  .body__containt .page__table .table-body .data {
    width: 100%;
    min-height: 60px;
    height: auto;
    border-radius: 15px;
    display: flex;
    align-items: center;
    transition: 0.3s ease;
    overflow: visible;
    position: relative;
    padding: 8px 0;
  }

  .body__containt .page__table .table-body .data:hover {
    background: #ffeeed;
  }

  .body__containt .page__table .table-body .data p {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 300;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding: 0 0.5rem;
    box-sizing: border-box;
  }

  .body__containt .page__table .table-headers p:nth-child(1),
  .body__containt .page__table .table-body .data p:nth-child(1) {
    width: 10%;
    flex: 0 0 10%;
  }

  .body__containt .page__table .table-headers p:nth-child(2),
  .body__containt .page__table .table-body .data p:nth-child(2) {
    width: 16%;
    flex: 0 0 16%;
  }

  .body__containt .page__table .table-headers p:nth-child(3),
  .body__containt .page__table .table-body .data p.cell-uuid {
    width: 30%;
    flex: 0 0 30%;
  }

  .body__containt .page__table .table-headers p:nth-child(4),
  .body__containt .page__table .table-body .data p:nth-child(4) {
    width: 10%;
    flex: 0 0 10%;
  }

  .body__containt .page__table .table-headers p:nth-child(5),
  .body__containt .page__table .table-body .data p:nth-child(5) {
    width: 16%;
    flex: 0 0 16%;
  }

  .body__containt .page__table .table-headers p:nth-child(6),
  .body__containt .page__table .table-body .data .dropdown {
    width: 18%;
    flex: 0 0 18%;
    position: relative;
    overflow: visible;
    z-index: 1;
  }

  .body__containt .page__table .table-body .data p.cell-uuid {
    overflow: visible;
    text-overflow: unset;
    white-space: normal;
    word-break: break-all;
    font-size: 12px;
    line-height: 1.35;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  }

  .body__containt .page__table .table-body .data .dropdown:focus-within,
  .body__containt .page__table .table-body .data .dropdown:hover {
    z-index: 20;
  }

  .dropdown-content {
    top: calc(100% + 4px);
    right: 0;
    left: auto;
    margin-top: 0;
    margin-right: 0;
    z-index: 1000;
    padding: 8px 0;
  }

  .dropdown-item {
    width: 100%;
    text-align: left;
    background: transparent;
    border: none;
    cursor: pointer;
  }

  ::v-deep .modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::v-deep .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    margin: 0 7rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
  }

  @media (max-width: 768px) {
    .body__containt .page__table {
      font-size: 11px;
    }

    .body__containt .page__table .table-headers,
    .body__containt .page__table .table-body {
      width: 245%;
    }

    .body__containt .page__buttons .button {
      font-size: 13px;
      padding: 5px 20px;
    }
  }
</style>
